






















































import {
  computed,
  defineComponent,
  ref,
  Ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import areaCode from '@/table/setting/areaCode';
import useAuth from '@/useAuth';

import getAreaCodes from '@/gql/areaCode/getAreaCodes.gql';
import deleteAreaCode from '@/gql/areaCode/deleteAreaCode.gql';
import getHubs from '@/gql/company/getHubs.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonFormWithAreaCodeEditor from '@/components/Setting/CommonFormWithAreaCodeEditor.vue';

const AreaCode = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonFormWithAreaCodeEditor,
  },
  setup() {
    const { me } = useAuth();
    const search: Ref<string> = ref('');
    const searchHub: Ref<any> = ref(null);
    const getAreaCodesResult = (data: any) => data.areasPaginate;
    // ==== Use to search User ==== //
    const getAreaCodesVariables = computed(() => {
      const vars: {[key: string]: any} = {
        filter: undefined,
        filterHub: undefined,
      };
      if (me.hub.hubType !== 'MAIN' || searchHub.value) {
        vars.filterHub = {
          column: 'ID',
          value: searchHub.value?.id || me.hubId,
        };
      }
      if (search.value) {
        vars.filter = {
          OR: [
            {
              column: 'CODE',
              operator: 'LIKE',
              value: `%${search.value}%`,
            },
            {
              column: 'NAME',
              operator: 'LIKE',
              value: `%${search.value}%`,
            },
          ],
        };
      }
      return vars;
    });

    const addAreaCodeModal = ref(null);
    const editAreaCodeId = ref(-1);

    // =============================================
    // ===== Use to delete AreaCode from system =====
    // =============================================
    const deleteAreaCodeModal = ref(null);
    const deleteAreaCodeMutation = useMutation(deleteAreaCode, {
      refetchQueries: ['getAreaCodes'],
    });
    function deleteAreaCodeAction(areaCodeId: number) {
      deleteAreaCodeMutation.mutate({
        id: areaCodeId,
      });
    }

    return {
      search,

      me,
      getHubs,
      searchHub,

      getAreaCodesResult,
      getAreaCodesVariables,
      getAreaCodesQuery: getAreaCodes,
      areaCodesTableOptions: areaCode,

      addAreaCodeModal,
      editAreaCodeId,

      deleteAreaCodeModal,
      deleteAreaCodeAction,
    };
  },
});

export default AreaCode;
